import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "container-fluid bg-dark py-5 mt-5 text-white-50 footer wow fadeIn",
  "data-wow-delay": "0.1s"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row g-5" }
const _hoisted_4 = { class: "col-lg-3 col-sm-6" }
const _hoisted_5 = { class: "col-lg-3 col-sm-6" }
const _hoisted_6 = { class: "row g-2 pt-2" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "col-lg-3 col-sm-6" }
const _hoisted_9 = {
  class: "position-relative mx-auto",
  style: {"max-width":"400px"}
}
const _hoisted_10 = { class: "container" }
const _hoisted_11 = { class: "copyright" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-6 text-center text-sm-start mb-3 mb-sm-0" }
const _hoisted_14 = { class: "col-sm-6 text-center text-sm-end" }
const _hoisted_15 = { class: "footer-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"col-lg-3 col-sm-6\" data-v-5bea3477><h5 class=\"text-white mb-4\" data-v-5bea3477>Get In Touch</h5><p class=\"mb-2\" data-v-5bea3477><i class=\"fa fa-map-marker-alt me-3\" data-v-5bea3477></i>Remera, Kigali - Rwanda</p><p class=\"mb-2\" data-v-5bea3477><i class=\"fa fa-phone-alt me-3\" data-v-5bea3477></i>+250 789 326 245</p><p class=\"mb-2\" data-v-5bea3477><i class=\"fa fa-envelope me-3\" data-v-5bea3477></i>info@estaterwanda.com</p><div class=\"d-flex pt-2\" data-v-5bea3477><a class=\"btn btn-outline-light btn-social\" href=\"#\" data-v-5bea3477><i class=\"fab fa-twitter\" data-v-5bea3477></i></a><a class=\"btn btn-outline-light btn-social\" href=\"#\" data-v-5bea3477><i class=\"fab fa-facebook-f\" data-v-5bea3477></i></a><a class=\"btn btn-outline-light btn-social\" href=\"#\" data-v-5bea3477><i class=\"fab fa-youtube\" data-v-5bea3477></i></a><a class=\"btn btn-outline-light btn-social\" href=\"#\" data-v-5bea3477><i class=\"fab fa-linkedin-in\" data-v-5bea3477></i></a></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("h5", { class: "text-white mb-4" }, "Quick Links", -1)),
          _createVNode(_component_router_link, {
            class: "btn btn-link text-white-50",
            to: "/about"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("About Us", -1)
            ])),
            _: 1,
            __: [2]
          }),
          _createVNode(_component_router_link, {
            class: "btn btn-link text-white-50",
            to: "/contact"
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode("Contact Us", -1)
            ])),
            _: 1,
            __: [3]
          }),
          _createVNode(_component_router_link, {
            class: "btn btn-link text-white-50",
            to: "/services"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("Our Services", -1)
            ])),
            _: 1,
            __: [4]
          }),
          _createVNode(_component_router_link, {
            class: "btn btn-link text-white-50",
            to: "/privacy"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode("Privacy Policy", -1)
            ])),
            _: 1,
            __: [5]
          }),
          _createVNode(_component_router_link, {
            class: "btn btn-link text-white-50",
            to: "/terms"
          }, {
            default: _withCtx(() => _cache[6] || (_cache[6] = [
              _createTextVNode("Terms & Condition", -1)
            ])),
            _: 1,
            __: [6]
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[8] || (_cache[8] = _createElementVNode("h5", { class: "text-white mb-4" }, "Photo Gallery", -1)),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleryImages, (image) => {
              return (_openBlock(), _createElementBlock("div", {
                key: image,
                class: "col-4"
              }, [
                _createElementVNode("img", {
                  class: "img-fluid rounded bg-light p-1",
                  src: image,
                  alt: "Gallery Image"
                }, null, 8, _hoisted_7)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _cache[9] || (_cache[9] = _createElementVNode("h5", { class: "text-white mb-4" }, "Newsletter", -1)),
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newsletterEmail) = $event)),
              class: "form-control bg-transparent w-100 py-3 ps-4 pe-5",
              type: "email",
              placeholder: "Your email"
            }, null, 512), [
              [_vModelText, _ctx.newsletterEmail]
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-primary py-2 position-absolute top-0 end-0 mt-2 me-2",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNewsletterSignup && _ctx.handleNewsletterSignup(...args)))
            }, " SignUp ")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[12] || (_cache[12] = _createTextVNode(" © ", -1)),
            _createVNode(_component_router_link, {
              class: "border-bottom",
              to: "/"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("Estate Rwanda", -1)
              ])),
              _: 1,
              __: [11]
            }),
            _cache[13] || (_cache[13] = _createTextVNode(", All Rights Reserved. Designed By ", -1)),
            _cache[14] || (_cache[14] = _createElementVNode("a", {
              class: "border-bottom",
              href: "https://tambagroup.xyz"
            }, "Tamba Group", -1))
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode("Home", -1)
                ])),
                _: 1,
                __: [15]
              }),
              _createVNode(_component_router_link, { to: "/cookies" }, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createTextVNode("Cookies", -1)
                ])),
                _: 1,
                __: [16]
              }),
              _createVNode(_component_router_link, { to: "/help" }, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("Help", -1)
                ])),
                _: 1,
                __: [17]
              }),
              _createVNode(_component_router_link, { to: "/faqs" }, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createTextVNode("FAQs", -1)
                ])),
                _: 1,
                __: [18]
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}